// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6992 ? "be74e82d" : chunkId) + "." + {"6992":"11e895b03d7b2c7c","8162":"808ab35df02a2f3d"}[chunkId] + ".js";
};